<!--
component: AppHeader
author: Ken Nakamura
description: ヘッダ
-->
<template>
  <div>
    <v-app-bar app dark color="#335566">
      <v-app-bar-nav-icon @click="drawer=true" v-show="menuBtnVisible"></v-app-bar-nav-icon>
      <v-toolbar-title :style="$vuetify.breakpoint.name=='xs'?'padding-left:0;font-size:0.5em;':''">
        {{ title }}
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <div v-show="titleMessageVisible">{{ titleMessage }}</div>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="openMenuNotice()" v-show="menuNoticeIconVisible" aria-label="お知らせ">
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>
      <v-btn @click="showManual()" color="#335577" v-show="manualBtnVisible">
        <span v-show="$vuetify.breakpoint.name!='xs'">操作マニュアル</span>
        <span v-show="$vuetify.breakpoint.name=='xs'"><v-icon>mdi-book-open-variant</v-icon></span>
      </v-btn>
      <div class="flex-grow-1"></div>
      <v-btn @click="back()" color="#336666" v-show="backBtnVisible">
        <span v-show="$vuetify.breakpoint.name!='xs'">前に戻る</span>
        <span v-show="$vuetify.breakpoint.name=='xs'"><v-icon>mdi-chevron-left</v-icon></span>
      </v-btn>
      <!--
      <v-btn to="/menu" v-show="homeBtnVisible" color="#666633">最初に戻る</v-btn>
      -->
      <v-btn @click="top()" v-show="homeBtnVisible" color="#666633">
        <span v-show="$vuetify.breakpoint.name!='xs'">最初に戻る</span>
        <span v-show="$vuetify.breakpoint.name=='xs'"><v-icon>mdi-chevron-double-left</v-icon></span>
      </v-btn>
      <v-btn @click="logout_check_dialog = true" v-show="logoutBtnVisible" light>ログアウト</v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      dark
      overlay-opacity="50"
      fixed
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group>
          <v-list-item
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :to="menuItem.url"
          >
            <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="logout_check_dialog" width="30%">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="primary">
            mdi-logout
          </v-icon>
          ログアウト
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          建築計画概要書閲覧システムからログアウトします。<br>
          よろしいですか？<br><br>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="logout_check_dialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            @click="logout()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
  </div>
</template>

<script>
import constants from '../common/constants'

const MENU_NOTICE_TARGET_AUTHORITIES = [0, 5]

export default {
  data: () => ({
    drawer: false,
    menuItems: constants.menuItems,
    logout_check_dialog: false,
  }),
  props: {
    title: {
      type: String,
      default: '建築計画概要書等閲覧システム'
    },
    backBtnVisible: {
      type: Boolean,
      default: true
    },
    homeBtnVisible: {
      type: Boolean,
      default: true
    },
    logoutBtnVisible: {
      type: Boolean,
      default: true
    },
    menuBtnVisible: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    titleMessage() {
      return this.$store.state.titleMessage;
    },
    titleMessageVisible() {
      return this.$store.state.mode == 1 && this.$store.state.userInfo?.newUser
        && this.$store.state.browseCountLimit > 0;
    },
    manualBtnVisible() {
      //return this.$store.state.manualBtnVisible;
      return this.$store.state.manualBtnVisible && 
        (!this.$store.state.manualOnlyNewUser || this.$store.state.userInfo.newUser);
    },
    manualUrl() {
      return './' + this.$store.state.manualFileName;
    },
    /**
     * 周知本文があり、対象権限の利用者にだけお知らせベルを表示する。
     *
     * @returns {boolean} ヘッダにお知らせアイコンを出す場合はtrue
     */
    menuNoticeIconVisible() {
      const authority = Number(this.$store.state.userInfo?.authority);
      if (!this.$store.state.menuNoticeHtml?.trim()) {
        return false;
      }
      return MENU_NOTICE_TARGET_AUTHORITIES.includes(authority);
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    top() {
      if (this.$store.state.userInfo.appMode > 0 && this.$store.state.userInfo.appMode < 0xff) {
        this.$router.replace('method');
      }
      else {
        this.$router.replace('menu');
      }
    },
    showManual() {
      window.open(this.manualUrl);
    },
    /**
     * ヘッダのベルアイコンから周知ダイアログを手動表示する。
     */
    openMenuNotice() {
      this.$store.commit('setMenuNoticeDialogOpen', true);
    },
    /**
     * 周知ダイアログを閉じた状態でログアウト画面へ遷移する。
     */
    logout() {
      this.logout_check_dialog = false;
      this.$store.commit('setMenuNoticeDialogOpen', false);
      this.$router.push('/');
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/common/common.css';

.nav-btns {
  text-align: right;
}
@media print {
  header {
    display: none;
  }
}

</style>
